import React from "react";
// ANT DESIGN COMPONENTS
import { Select } from "antd";
// ELEVATOR ICONS ELEVATOR STATUS
import elDown from "../../../assets/icons/elevatorStatus/el-down.svg";
import elUp from "../../../assets/icons/elevatorStatus/el-up.svg";
import elClose from "../../../assets/icons/elevatorSingle/el-close.svg";
import elOpen from "../../../assets/icons/elevatorSingle/el-open.svg";
import elFrontCloseRearClose from "../../../assets/icons/elevatorDouble/el-front-close-rear-close.svg";
import elFrontCloseRearOpen from "../../../assets/icons/elevatorDouble/el-front-close-rear-open.svg";
import elFrontOpenRearClose from "../../../assets/icons/elevatorDouble/el-front-open-rear-close.svg";
import elFrontOpenRearOpen from "../../../assets/icons/elevatorDouble/el-front-open-rear-open.svg";
// INTERFACES
import { IconsInterface } from "../../../interfaces/IconDefinitions";

export default function SelectIconElevator({
  setValue,
  value,
}: {
  setValue: (newValue: string) => void;
  value: string;
}) {
  // ************************************************ */
  // GLOBAL VARIABLES ******************************* */
  const { Option } = Select;
  const ICONS: IconsInterface[] = [
    { id: "elUp", name: "Up", icon: elUp },
    { id: "elDown", name: "Down", icon: elDown },
    { id: "elClose", name: "door", icon: elClose },
    { id: "elOpen", name: "Open", icon: elOpen },
    {
      id: "elFrontCloseRearClose",
      name: "Front Close Rear Close",
      icon: elFrontCloseRearClose,
    },
    {
      id: "elFrontCloseRearOpen",
      name: "Front Close Rear Open",
      icon: elFrontCloseRearOpen,
    },
    {
      id: "elFrontOpenRearClose",
      name: "Front Open Rear Close",
      icon: elFrontOpenRearClose,
    },
    {
      id: "elFrontOpenRearOpen",
      name: "Front Open Rear Open",
      icon: elFrontOpenRearOpen,
    },
  ];

  // ************************************************ */
  // USE STATE VARIABLES **************************** */

  // ************************************************ */
  // REDUX SLICE VARIABLES ************************** */

  // ************************************************ */
  // SERVICES AND API CALLS ************************* */

  // ************************************************ */
  // FUNCTIONS ************************************** */
  const onChange = (newValue: string) => {
    setValue(newValue);
  };

  // ************************************************ */
  // USE EFFECT ************************************* */

  // ************************************************ */
  // COMPONENT ************************************** */
  return (
    <Select className="generalStyles__width100" size="small" onChange={onChange} value={value}>
      {ICONS.map((item: IconsInterface) => (
        <Option key={item.id} value={item.id}>
          <img src={item.icon} alt={item.name} /> {item.name}
        </Option>
      ))}
    </Select>
  );
}
